(function () {
  function headerOffset() {
    var root = document.documentElement;
    var topPx = parseFloat(getComputedStyle(root).getPropertyValue('--header-height-top'));
    if (!isNaN(topPx)) return Math.round(topPx);

    var headerVar = getComputedStyle(root).getPropertyValue('--header-height').trim();
    if (headerVar && headerVar !== 'auto') {
      var h = parseFloat(headerVar);
      if (!isNaN(h)) return Math.round(h);
    }

    var headerBar = document.querySelector('.shopify-section-header .header__top');
    if (headerBar) return Math.round(headerBar.getBoundingClientRect().height);

    var sticky = document.querySelector('.shopify-section-header-sticky');
    if (sticky) return sticky.offsetHeight;
    var header = document.querySelector('header');
    return header ? header.offsetHeight : 0;
  }

  /** Offset so section headings aren’t hidden under fixed UI when clicking PDP sticky nav links. */
  function stickyScrollReserve(navRoot) {
    if (!navRoot) return headerOffset() + 56;

    var mobile = window.matchMedia('(max-width: 749px)').matches;
    if (mobile) {
      return headerOffset() + 48;
    }

    var deskBar = navRoot.querySelector('.product-sticky-bar--desktop');
    var deskVisible =
      navRoot.classList.contains('product-sticky--active') &&
      deskBar &&
      window.getComputedStyle(deskBar).display !== 'none';

    if (deskVisible && deskBar.getBoundingClientRect().height > 0) {
      return Math.ceil(deskBar.getBoundingClientRect().height + 12);
    }

    return headerOffset() + 56;
  }

  /** True when `.product__outer` (hero row) no longer overlaps the viewport below the sticky header slice. Avoids sentinel inside sticky column (never scrolled past). */
  function scrolledPastHero(outerEl) {
    if (!outerEl) return false;
    var cutoff = headerOffset() + 2;
    return outerEl.getBoundingClientRect().bottom <= cutoff;
  }

  /** True when primary PDP add-to-cart button is above the sticky header slice. */
  function scrolledPastAddButton(btnEl) {
    if (!btnEl) return false;
    var cutoff = headerOffset() + 2;
    return btnEl.getBoundingClientRect().bottom <= cutoff;
  }

  function activeCarouselImage(isMobile) {
    var sel = isMobile
      ? '.product__media-wrapper--mobile .js-media-list'
      : '.product__media-wrapper:not(.product__media-wrapper--mobile) .js-media-list';
    var wrapper = document.querySelector(sel);
    if (!wrapper) return null;
    var slide = wrapper.querySelector('.swiper-slide-active img');
    return slide || wrapper.querySelector('img');
  }

  function copyCarouselImage(sectionId, root, desktopTarget, mobileTarget) {
    var deskSrc = activeCarouselImage(false);
    var mobSrc = activeCarouselImage(true) || deskSrc;
    function apply(wrap, srcImg) {
      if (!wrap || !srcImg) return;
      var im = wrap.querySelector('img');
      if (!im) return;
      var nextSrc = srcImg.currentSrc || srcImg.src;
      if (nextSrc && im.getAttribute('src') !== nextSrc) {
        im.src = nextSrc;
      }
      if (srcImg.srcset && im.getAttribute('srcset') !== srcImg.srcset) {
        im.setAttribute('srcset', srcImg.srcset);
      }
      if (srcImg.alt != null && im.alt !== srcImg.alt) {
        im.alt = srcImg.alt;
      }
    }
    apply(desktopTarget, deskSrc);
    apply(mobileTarget, mobSrc);
  }

  /** Strip PDP main-column RRP / Save when cloning into sticky bars. */
  function stripStickyPriceClone(rootEl) {
    if (!rootEl) return;
    rootEl.querySelectorAll('.wrapper_compare_discount').forEach(function (node) {
      node.remove();
    });
    rootEl.querySelectorAll('dd.price__compare').forEach(function (node) {
      node.remove();
    });
    rootEl.querySelectorAll('dt.price__compare').forEach(function (node) {
      node.remove();
    });
  }

  function syncStickyFromDom(root, sectionId) {
    var mainPrice = document.getElementById('price-' + sectionId);
    root.querySelectorAll('[data-sticky-price], [data-sticky-price-mobile]').forEach(function (node) {
      if (mainPrice) {
        node.innerHTML = mainPrice.innerHTML;
        stripStickyPriceClone(node);
      }
    });

    var titleEl = document.querySelector('#ProductInfo-' + sectionId + ' .product__title');
    if (titleEl) {
      var text = titleEl.textContent.trim();
      root.querySelectorAll('[data-sticky-title], [data-sticky-title-mobile]').forEach(function (el) {
        el.textContent = text;
      });
    }

    var thumbDesk = root.querySelector('[data-sticky-thumb-wrap]');
    var thumbMob = root.querySelector('[data-sticky-thumb-wrap-mobile]');
    copyCarouselImage(sectionId, root, thumbDesk, thumbMob);

    syncAddButton(root, sectionId);
  }

  function syncAddButton(root, sectionId) {
    var mainBtn = document.querySelector('#product-form-' + sectionId + ' [name="add"]');
    if (!mainBtn) return;

    root.querySelectorAll('[data-sticky-submit], [data-sticky-submit-mobile]').forEach(function (b) {
      var preserveForm = b.getAttribute('form');
      var hasDeskMarker = b.hasAttribute('data-sticky-submit');
      var hasMobMarker = b.hasAttribute('data-sticky-submit-mobile');

      b.disabled = mainBtn.disabled;
      b.innerHTML = mainBtn.innerHTML;
      b.className = mainBtn.className.trim().replace(/\s+/g, ' ') + ' product-sticky-bar__submit';

      if (preserveForm) b.setAttribute('form', preserveForm);
      else b.removeAttribute('form');

      ['aria-disabled', 'aria-haspopup'].forEach(function (attr) {
        if (mainBtn.hasAttribute(attr)) b.setAttribute(attr, mainBtn.getAttribute(attr));
        else b.removeAttribute(attr);
      });

      if (mainBtn.classList.contains('loading')) {
        b.classList.add('loading');
      } else {
        b.classList.remove('loading');
      }

      if (hasDeskMarker) b.setAttribute('data-sticky-submit', '');
      if (hasMobMarker) b.setAttribute('data-sticky-submit-mobile', '');
    });
  }

  function observeSlides(root, sectionId, carousel) {
    if (!carousel) return;
    var obs = new MutationObserver(function () {
      syncStickyFromDom(root, sectionId);
    });
    obs.observe(carousel, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    return obs;
  }

  function initNavSmoothScroll(root) {
    root.querySelectorAll('.product-sticky-bar__nav-link[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.length < 2) return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        var top =
          target.getBoundingClientRect().top + window.scrollY - stickyScrollReserve(root);
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  }

  function init() {
    var root = document.querySelector('[data-product-sticky-root]');
    if (!root) return;
    var sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    var mainWrap = document.getElementById('MainProduct-' + sectionId);
    var heroOuter = mainWrap ? mainWrap.querySelector('.product__outer') : null;
    var mainBtn = document.querySelector('#product-form-' + sectionId + ' [name="add"]');
    var mobBar = root.querySelector('.product-sticky-bar--mobile-bottom');
    if (!heroOuter && !mainBtn) return;

    /** Chrome: pin width to layout viewport (clientWidth) — avoids ~5px horizontal overflow vs %/inset math. */
    function pinMobileStickyBarWidth() {
      if (!mobBar) return;
      if (!window.matchMedia('(max-width: 749px)').matches) {
        mobBar.style.removeProperty('width');
        mobBar.style.removeProperty('max-width');
        mobBar.style.removeProperty('left');
        mobBar.style.removeProperty('right');
        mobBar.style.removeProperty('box-sizing');
        return;
      }
      var w = Math.round(document.documentElement.clientWidth);
      mobBar.style.boxSizing = 'border-box';
      mobBar.style.left = '0';
      mobBar.style.right = 'auto';
      mobBar.style.width = w + 'px';
      mobBar.style.maxWidth = w + 'px';
    }

    initNavSmoothScroll(root);

    function setActive(show) {
      root.classList.toggle('product-sticky--active', show);
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      document.body.classList.toggle('product-sticky-mobile-padding', !!(show && mobile));
    }

    function updateStickyVisibility() {
      pinMobileStickyBarWidth();
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var past = mobile && mainBtn ? scrolledPastAddButton(mainBtn) : scrolledPastHero(heroOuter);
      if (!heroOuter && !mobile) {
        past = scrolledPastAddButton(mainBtn);
      }
      setActive(past);
    }

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);

    /** Mobile toolbar / bfcache / SPA-style nav: re-measure so fixed bar matches layout viewport. */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        syncStickyFromDom(root, sectionId);
      }
      updateStickyVisibility();
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateStickyVisibility);
      window.visualViewport.addEventListener('scroll', updateStickyVisibility);
    }

    var mainPrice = document.getElementById('price-' + sectionId);
    if (mainPrice) {
      var moPrice = new MutationObserver(function () {
        syncStickyFromDom(root, sectionId);
      });
      moPrice.observe(mainPrice, { subtree: true, childList: true, characterData: true });
    }

    if (mainBtn) {
      var moBtn = new MutationObserver(function () {
        syncAddButton(root, sectionId);
      });
      moBtn.observe(mainBtn, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-haspopup', 'class'],
      });
    }

    var deskCarousel = document.querySelector(
      '.product__media-wrapper:not(.product__media-wrapper--mobile) .js-media-list',
    );
    var mobCarousel = document.querySelector('.product__media-wrapper--mobile .js-media-list');
    observeSlides(root, sectionId, deskCarousel);
    observeSlides(root, sectionId, mobCarousel);

    function kickLayout() {
      syncStickyFromDom(root, sectionId);
      updateStickyVisibility();
    }

    kickLayout();
    requestAnimationFrame(function () {
      requestAnimationFrame(kickLayout);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
